<app-tours-search [tours]="tours" [isForReseller]="true" [pagination]="toursPagination" (tourFilterTrigger)="onTourFilter($event)" (tourSelectedTrigger)="onTourSelected($event)"></app-tours-search>

<app-message-panel [preloading]="false"></app-message-panel>